import { Component, OnInit, ViewChild, ViewContainerRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { CmsService } from '../service/cms.service';
import { CmsLoaderService } from '../service/cms-loader.service';
import { CmsModule } from '../entity/cms-module';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-cms-generator',
  templateUrl: './cms-generator.component.html',
  styleUrls: ['./cms-generator.component.scss']
})
export class CmsGeneratorComponent implements OnInit, OnDestroy {
  cmsTypeSubscription: Subscription;

  @ViewChild('container', { read: ViewContainerRef, static: true })
  container: ViewContainerRef;

  constructor(
    private route: ActivatedRoute,
    private cmsService: CmsService,
    private cmsLoader: CmsLoaderService,
  ) { }

  ngOnInit() {
    this.cmsTypeSubscription = this.route.data
      .pipe(
        map(data => data.cmsModule as CmsModule),
        filter(cmsMeta => !isNullOrUndefined(cmsMeta)),
        map(cmsMeta => {
          return Array.of('cms', cmsMeta.moduleKey.toLowerCase().replace(/_/g, '-'),  cmsMeta.template).join('-');
        }),
      ).subscribe(selector => {
        // 為了解決中間模組轉換時，會一直累加內容區塊，參考舊的寫法有刪除container參數的動作
        // 不確定是否正確寫法，有問題請再修正。
        this.container.clear();

        this.cmsLoader.load(selector, this.container);
      });
  }

  ngOnDestroy() {
    if (this.cmsTypeSubscription) {
      this.cmsTypeSubscription.unsubscribe();
    }
  }
}
